<template>
  <b-button
    :variant="variant"
    :type="type"
    :block="block"
    :pill="pill"
    :disabled="loading || disabled"
    @click="!!onClick ? onClick : null"
  >
    <span v-if="!loading">{{text}}</span>
    <b-spinner v-if="loading" small type="grow"></b-spinner>
    <span v-if="loading">{{!!loadingText ? loadingText :  text}}</span>
  </b-button>
</template>

<script>
  export default {
    props: {
      text: {
        type: String,
        required: true,
      },
      loadingText: {
        type: String,
        required: false,
      },
      variant: {
        type: String,
        required: true,
      },
      loading: {
        type: Boolean,
        required: false,
        default: false,
      },
      block: {
        type: Boolean,
        required: false,
        default: true,
      },
      pill: {
        type: Boolean,
        required: false,
        default: false,
      },
      type: {
        type: String,
        required: false,
        default: 'button',
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      onClick: {
        type: Function,
        required: false,
      },
    },
  };
</script>
